(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5969);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts + 1 modules
var Container = __webpack_require__(4232);
// EXTERNAL MODULE: ./layout/Layout/index.ts + 17 modules
var Layout = __webpack_require__(2092);
// EXTERNAL MODULE: ./node_modules/react-typed/dist/react-typed.js
var react_typed = __webpack_require__(7788);
var react_typed_default = /*#__PURE__*/__webpack_require__.n(react_typed);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/organisms/PWA/index.tsx



var InstallPWA = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), supportsPWA = ref[0], setSupportsPWA = ref[1];
    var ref1 = (0,react.useState)(null), promptInstall = ref1[0], setPromptInstall = ref1[1];
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        var handler = function(e) {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);
        return function() {
            return window.removeEventListener("transitionend", handler);
        };
    }, [
        router.isReady
    ]);
    var onClick = function(evt) {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };
    if (!supportsPWA) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: " my-8 text-sm font-bold",
                    children: "You can also download the app on desktop (Magic of PWA)."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "block gradient-border transition transition-300 rounded-md px-4 py-2 headline hover:gradient-bg hover:text-off-white",
                    id: "setup_button",
                    "aria-label": "Install app",
                    title: "Install app",
                    onClick: onClick,
                    children: "Download App"
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./pages/index.tsx





var IndexPage = function() {
    var talkAbout = [
        "React",
        "JavaScript",
        "TypeScript",
        "Redux",
        "Jamstack",
        "Next.js",
        "RESTful APIs",
        "HTML",
        "CSS",
        "PHP",
        "Python",
        "Swift",
        "Kotlin",
        "React-Native",
        "Tailwind",
        "GCP",
        "AWS", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        title: "Krutik Parikh",
        description: "A Software Engineer with a focus on Node.js, React.js and JavaScript. I have more than 5 years experience working in software engineering.",
        keywords: [
            "Software Engineer",
            "Krutik Parikh",
            "Parikh Krutik",
            "Krutik",
            "parikrut",
            "Software Consulting",
            "Front-End",
            "Full-Stack",
            "React",
            "Node",
            "TypeScript",
            "JavaScript",
            "CSS",
            "Tailwind",
            "Back-End",
            "Full-Stack", 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "headline mt-20 text-3xl md:text-5xl lg:text-6xl",
                    children: "Hey, I'm Krutik Parikh \uD83D\uDC4B"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: " my-8 text-lg",
                    children: [
                        "I am a passionate Software Engineer, who specialised in Full-Stack development using Node, React, and TypeScript/Javascript. As an advocate for web performance and accessibility and an evangelist for the Jamstack, I create amazing web applications to make the internet a better place. You can talk to me about",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_typed_default()), {
                            loop: true,
                            typeSpeed: 80,
                            backSpeed: 20,
                            strings: talkAbout,
                            smartBackspace: true,
                            backDelay: 1000,
                            loopCount: 0,
                            showCursor: true,
                            cursorChar: "|"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: " my-8 text-sm font-bold",
                    children: "This portfolio is created with Next.js, TypeScript and Tailwind."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallPWA, {})
            ]
        })
    });
};
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [377,336,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);